import React from 'react'
import HeaderLogo from './common/HeaderLogo'
import { Card } from 'reactstrap'

export default function Privacy() {
    return (
        <>
        <HeaderLogo />
        <Card>
            <h4>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem excepturi, officiis tenetur quasi assumenda deserunt dolor doloremque non cum tempora praesentium inventore harum corporis quibusdam perferendis. Modi commodi animi similique dolore tempora amet earum quae unde tempore obcaecati, iure optio nisi, doloribus dolorum molestiae labore quaerat, minima debitis sunt iusto.
            </h4>
        </Card>
        </>
    )
}
